module.exports = __webpack_public_path__ + "media/assets/svgs/menu-dark-f8a36116d14d70573d5fdb912daf459b.svg";